import React from 'react'
import { IconShare } from '@tabler/icons-react'
import { ThemeConfig } from '../../utils/themeConfig'

interface ShareReportButtonProps {
  onClick: () => void
  themeConfig: ThemeConfig
  className?: string
}

const ShareReportButton: React.FC<ShareReportButtonProps> = ({ onClick, themeConfig, className }) => {
  return (
    <div
      className={`flex flex-col items-center justify-center cursor-pointer p-3 transition-all duration-300 hover:scale-105 ${className || ''}`}
      onClick={onClick}
      style={{ backgroundColor: themeConfig.backgroundColor }}
    >
      <IconShare size={26} color={themeConfig.primaryColor} />
      <span className="text-gray-500 text-xs font-medium mt-1">分享报告</span>
    </div>
  )
}

export default ShareReportButton
